/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneIcon as ResolvedStandaloneIcon } from 'base/components/standalone/Icon';

export const Icon: typeof ResolvedStandaloneIcon = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneIcon {...props} />
        </ErrorBoundary>
    );
});

export type IconProps = PropsFromComponent<typeof Icon>;

/** @deprecated Use slot architecture instead */
export const IconWith = (extras: DynamicStandaloneExtras): typeof Icon => {
    return function Icon(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Icon');
        return <ResolvedStandaloneIcon {...mergeProps({ options: { theme } }, props)} />;
    }
}